import { APIError } from '../core/errors';
import httpClient from '../services/http.service';
import { BASE_URL } from './api-constants';


const _api_base_url = `${BASE_URL}/metadata`;
interface metadataResponse {
  
  name:string;
  value:string;

}

export const getMetadata = async(storeCode: string): Promise<metadataResponse> => {
  try {
    const url = `${_api_base_url}/${storeCode}`;

    const response = await httpClient.get(url);
    return response.data;
} catch (error) {
    console.error(error);
    throw new APIError(error);
}
};
